import { render, staticRenderFns } from "./modalLinkSquadPlayer.vue?vue&type=template&id=0548f8a6&"
import script from "./modalLinkSquadPlayer.vue?vue&type=script&lang=js&"
export * from "./modalLinkSquadPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports